import { Component } from '@angular/core';


export class SkyKeyInfoLabelComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-key-info-label',
  template: `<ng-content></ng-content>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
